var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTwitterCircularFilled = function SvgTwitterCircularFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28c7.732 0 14-6.268 14-14S21.732 0 14 0 0 6.268 0 14s6.268 14 14 14Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.969 8.791a7.164 7.164 0 0 1-2.063.566 3.602 3.602 0 0 0 1.58-1.987 7.188 7.188 0 0 1-2.28.872 3.59 3.59 0 0 0-6.118 3.274 10.193 10.193 0 0 1-7.4-3.751 3.589 3.589 0 0 0 1.111 4.793 3.573 3.573 0 0 1-1.627-.45v.046c0 1.74 1.237 3.19 2.88 3.52a3.598 3.598 0 0 1-1.622.062 3.594 3.594 0 0 0 3.354 2.493 7.205 7.205 0 0 1-5.315 1.487 10.163 10.163 0 0 0 5.503 1.613c6.604 0 10.216-5.471 10.216-10.215 0-.156-.005-.311-.011-.465a7.277 7.277 0 0 0 1.792-1.858Z",
    fill: "#fff"
  })));
};

export default SvgTwitterCircularFilled;